// extracted by mini-css-extract-plugin
export default {"item__option":"ItemEditions_item__option__uFpQs"};